export default "__VITE_ASSET__BbBrqWjr__"